//imports
import {
    DEVICE_MODEL_CREATE_EDIT_OPEN_MODAL,
    DEVICE_MODEL_CREATE_REQUEST,
    DEVICE_MODEL_CREATE_RESULT,
    DEVICE_MODEL_UPDATE_REQUEST,
    DEVICE_MODEL_UPDATE_RESULT,
    DEVICE_MODEL_GET_REQUEST,
    DEVICE_MODEL_GET_RESULT,
    DEVICE_MODEL_SEARCH_UNIT_TYPES,
    DEVICE_MODEL_SEARCH_UNIT_TYPES_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    create: null,
    update: null,
    deviceModel: null,
    current: null,
    unitTypes: [],
    loadingUnitTypes: []
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case DEVICE_MODEL_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: true, current: action.payload }

        case DEVICE_MODEL_CREATE_REQUEST:
            return { ...state, loading: true }

        case DEVICE_MODEL_CREATE_RESULT:
            return { ...state, loading: false, create: action.payload }

        case DEVICE_MODEL_UPDATE_REQUEST:
            return { ...state, loading: true }

        case DEVICE_MODEL_UPDATE_RESULT:
            return { ...state, loading: false, update: action.payload }

        case DEVICE_MODEL_GET_REQUEST:
            return { ...state, loading: true }

        case DEVICE_MODEL_GET_RESULT:
            return { ...state, loading: false, deviceModel: action.payload }

        case DEVICE_MODEL_SEARCH_UNIT_TYPES:
            return { ...state, loadingUnitTypes: true }

        case DEVICE_MODEL_SEARCH_UNIT_TYPES_RESULT:
            return { ...state, loadingUnitTypes: false, unitTypes: action.payload }

        case CLEAR_REDUX:
            return ["", "CREATE_EDIT_DEVICE_MODEL"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
